<style lang="scss">
  @use "../../assets/css/design-system/colors";
  @use "../../assets/css/design-system/mixins";
  @use "../../assets/css/design-system/utils";

  div {
    display: flex;
    align-items: center;
    justify-content: center;

    gap: utils.in_rem(8px);
    padding: utils.in_rem(6px) utils.in_rem(8px);
    border-radius: 44px;
    @include mixins.caption();

    /// Sizes

    &.xsmall {
      height: utils.in_rem(22px);

      > img {
        margin-left: utils.in_rem(-4px);
        height: utils.in_rem(16px);
        width: utils.in_rem(16px);
      }
    }

    &.small {
      height: utils.in_rem(26px);

      > img {
        margin-left: utils.in_rem(-4px);
        height: utils.in_rem(20px);
        width: utils.in_rem(20px);
      }
    }

    &.large {
      height: utils.in_rem(32px);

      > img {
        margin-left: utils.in_rem(-4px);
        height: utils.in_rem(24px);
        width: utils.in_rem(24px);
      }
    }

    > img {
      background-color: white;
      border-radius: 50%;
      object-fit: cover;
    }
  }

  // button included for 'x' icon styling
  div,
  button {
    /// Kinds

    &.default {
      @include colors.background-color(interfaceSwGrey_5);
      @include colors.color(primary_50);
    }

    &.hover {
      @include colors.background-color(primary_5);
      @include colors.color(primary_70);
    }

    &.active {
      @include colors.background-color(primary_10);
      @include colors.color(primary_60);
    }

    &.success {
      @include colors.background-color(systemPositive_10);
      @include colors.color(systemPositive_100);
    }

    &.warning {
      @include colors.background-color(systemWarning_10);
      @include colors.color(systemWarning_100);
    }

    &.error {
      @include colors.background-color(systemError_10);
      @include colors.color(systemError_100);
    }

    &.disabled {
      @include colors.background-color(interfaceSwGrey_10);
      @include colors.color(textLighterBlack);
    }

    &.light-blue {
      @include colors.background-color(primary_5);
      @include colors.color(primary_60);
    }

    &.dark-blue {
      @include colors.background-color(primary_20);
      @include colors.color(primary_70);
    }
  }

  button {
    border: 0;
    border-radius: 6px;
    cursor: pointer;
    padding: 0;
  }
</style>

<script>
  import Icon from "./Icon.svelte";

  let {
    kind = "default",
    size = "large",
    leadingIcon = "",
    leadingSrc = "",
    showX = true,
    xClick = () => {},
    children,
    ...rest
  } = $props();
</script>

<div class="{kind} {size}">
  {#if leadingSrc}
    <img src={leadingSrc} alt="icon" />
  {/if}

  {#if leadingIcon}
    <Icon class={leadingIcon} size="small" />
  {/if}

  {@render children()}

  {#if showX}
    <button class={kind} tabindex="-1" onclick={xClick} {...rest}>
      <Icon class="far fa-times" size="small" />
    </button>
  {/if}
</div>
